<template>
  <div>
    <div v-if="!isEdit" class="detail-title" :style="`color:${ getPrimary(color)}`">
      {{ $t("Views.Customer.discountByCategory") }}
    </div>
    <material-table
      :headers="headers"
      :items="items"
      :has-paginate="false"
      @add="addFn"
      @remove="removeFn"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import ENUMS from '@/dict/enums'
export default {
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    isEdit: {
      type: Boolean,
      default: () => false
    },
    isUpdate: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const $t = this.$t.bind(this)
    return {
      categoryList: [],
      sectionValid: [],
      rateValid: [],
      headers: [
        {
          width: 400,
          text: $t('Views.Goods.categoryName'),
          render: (h, param) => {
            return h('material-cascader-box', {
              props: {
                state: this.categoryList,
                config: {
                  label: 'name',
                  value: 'id',
                  children: 'items',
                  checkStrictly: true
                },
                value: param.row.productCategoryId
              },
              on: {
                change: value => {
                  if (value) {
                    const c_id = value[value.length - 1]
                    this.getProductCount({ categoryId: c_id }).then(
                      res => {
                        this.$set(
                          this.items,
                          param.index,
                          {
                            releateProductQuantity: res,
                            productCategoryId: c_id,
                            detail: [{
                              discountValue: '',
                              maxQuantity: '',
                              minQuantity: 1
                            }]
                          }
                        )
                      }
                    )
                  }
                }
              }
            })
          }
        },
        {
          text: $t('Views.Customer.relativeGoods'),
          value: 'releateProductQuantity'
        },
        {
          width: 440,
          text: $t('Views.Customer.quantity'),
          render: (h, param) => {
            return h('ams-quantity-section', {
              props: {
                data: param.row.detail,
                rules: [
                  v => !!v || $t('Core.Valid.required'),
                  v => v * 1 <= 99999 || $t('Core.Valid.max', { max: 99999 }),
                  v => v * 1 >= 1 || $t('Core.Valid.min', { min: 1 })
                ],
                config: {
                  max: 'maxQuantity',
                  min: 'minQuantity'
                },
                max: 99999, // 允许的最大值
                min: 1, // 允许的最小值
                step: 1000 // 每次新增一条的最大值和最小值的区间步长
              },
              on: {
                change: (source, valid) => {
                  if (source === null) return
                  this.sectionValid[param.index] = valid
                  this.$set(this.items[param.index], 'detail', source)
                }
              }
            })
          }
        },
        {
          width: 200,
          text: $t('Views.Customer.discountRate'),
          render: (h, param) => {
            return h('ams-ipt-box', {
              props: {
                data: param.row.detail,
                rules: [
                  v => !!v || $t('Core.Valid.required'),
                  v => v * 1 <= 100 || $t('Core.Valid.max', { max: 100 }),
                  v => v * 1 >= 0 || $t('Core.Valid.min', { min: 0 }),
                  v => {
                    if (!String(v) || !String(v).split('.')[1]) return false
                    return String(v).split('.')[1].length < 3 || $t('Core.Valid.float', { digit: 2 })
                  }
                ],
                config: {
                  value: 'discountValue'
                },
                suffix: '%'
              },
              on: {
                change: (source, valid) => {
                  if (source === null) return
                  this.rateValid[param.index] = valid
                  this.$set(this.items[param.index], 'detail', source)
                }
              }
            })
          }
        }
      ],
      items: []
    }
  },
  computed: {
    color() {
      return this.$store.state.app.color
    }
  },
  watch: {
    items: {
      deep: true,
      handler(val) {
        // TODO: 待优化
        this.setDisabledFn(this.categoryList, val)
      }
    },
    value(newVal, oldVal) {
      if (newVal) {
        this.items = this.$_.cloneDeep(newVal)
      }
    }
  },
  created() {
    this.items = this.$_.cloneDeep(this.value)
  },
  mounted() {
    this.getCategoryList().then(res => {
      this.categoryList = res
    })
    this.items[0].productCategoryId &&
        this.getProductCount({ categoryId: this.items[0].productCategoryId }).then(res => {
          this.$set(this.items[0], 'releateProductQuantity', res)
        })
    if (!this.isEdit) {
      this.headers.push({
        text: this.$t('Core.System.operate'),
        value: 'action',
        isActions: true
      })
    }
  },
  methods: {
    ...mapActions('goods', ['getCategoryList', 'getProductCount']),
    setDisabledFn(source, target) {
      // 筛选禁用项
      let flag = target.length; const cids = target.map(item => item.productCategoryId)

      for (let i = 0, len = source.length; i < len; i++) {
        const item = source[i]
        if (flag && cids.includes(item.id)) {
          flag--
          item.disabled = true
        } else {
          item.disabled = false
        }

        if (item.items) {
          this.setDisabledFn(item.items, target)
        }
      }
      this.categoryList = Object.assign([], source)
    },
    getPrimary(color) {
      return ENUMS.primaryColor[color]
    },
    addFn(index, key) {
      this.items.splice(index + 1, 0, {
        productCategoryId: '',
        detail: null
      })
    },
    removeFn(index, key) {
      this.items.splice(index, 1)
    },
    emitChange() {
      this.$emit('input', this.items)
      const sectionValid = this.items.every((item, index) => {
        return !item.productCategoryId ? true
          : this.sectionValid[index] ? this.sectionValid[index].validate() : (this.isUpdate || (this.isEdit && true))
      })
      const rateValid = this.items.every((item, index) => {
        return !item.productCategoryId ? true : (
          this.rateValid[index] ? this.rateValid[index].validate() : (this.isUpdate || (this.isEdit && true))
        )
      })
      const categoryValid = this.items.filter(item => item.productCategoryId).length > 0

      return {
        section: sectionValid,
        rate: rateValid,
        category: categoryValid
      }
    }
  }
}
</script>
